// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"85020e2e","576":"459c98b6","595":"5d6868d6","906":"b4caeb08","951":"a057815e","972":"e303d014","982":"fb552c1d"}[chunkId] + ".chunk.js";
};